import axiosInstance from "@/lib/axios.instance";
import { encodePathSegment } from "./path.utils";

export interface AiDraftRequest {
  document_id: string;
  text_selected: string;
  outline?: string;
  document_length?: string;
  next_section?: boolean;
  thread_id?: string;
}

export enum AiDraftOption {
  WriteClause = "write_clause",
  WriteDefinition = "write_definition",
  MakeShorter = "make_shorter",
  MakeLonger = "make_longer",
  SimplifyLanguage = "simplify_language",
  ComplexifyLanguage = "complexify_language",
  Summarise = "summarizer",
  DraftFullDocument = "draft_full_document",
  DraftOutline = "outline",
}

export interface AiDraftResponse {
  response: string;
  thread_id?: string;
  stopped?: string | boolean;
}

export const aiDraft = async (
  option: AiDraftOption,
  data: AiDraftRequest
): Promise<AiDraftResponse> => {
  const url =
    option === AiDraftOption.DraftOutline
      ? `/ai/draft/assist/outline`
      : option === AiDraftOption.DraftFullDocument
        ? `/ai/draft/assist/document`
        : `/ai/draft/${encodePathSegment(option)}`;
  const response = await axiosInstance.post(url, data);
  return response.data;
};
